// Extracted from ./notification.tsx so React Fast Refresh keeps working
// — the component file now only exports components, and the CVA
// constant + types live here.

import type * as React from "react";
import { cva, type VariantProps } from "class-variance-authority";

export const notificationVariants = cva("relative flex items-start gap-3 rounded-lg p-2", {
  variants: {
    variant: {
      default: "bg-neutral-50",
      empty: "bg-neutral-50",
      success: "bg-green-50",
      info: "bg-blue-50",
      warning: "bg-yellow-50",
      error: "bg-red-50",
    },
  },
  defaultVariants: {
    variant: "default",
  },
});

export type NotificationVariant = NonNullable<VariantProps<typeof notificationVariants>["variant"]>;

export interface NotificationProps {
  variant?: NotificationVariant;
  title: React.ReactNode;
  description?: React.ReactNode;
  className?: string;
  /** Show a chevron toggle to expand/collapse the description. */
  expandable?: boolean;
  /** Initial expanded state when `expandable` is true. Defaults to `true`. */
  defaultExpanded?: boolean;
  /** When provided, shows a dismiss (×) button. */
  onDismiss?: () => void;
}
